export default "__VITE_ASSET__03d65a6b__"